import { useState } from "react";
import { useDispatch , useSelector} from "react-redux";
import { loginUserAsync } from "../features/auth/authSlice";
// import { loginSuccess } from "../features/auth/authSlice";
// import { loginUser } from "../features/auth/authAPI";
import { useNavigate, Link } from "react-router-dom";
import signup from "../assets/img/signup.jpg";


function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const { error } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(loginUserAsync(form));

    if (result.meta.requestStatus === "fulfilled") {
      navigate("/");
    } else {
      alert(result.payload);
    }
  };


  return (
    <div className="container d-flex align-items-center justify-content-center vh-100">
      <div className="col-md-6">
        <div className="outer-form  p-4">
          <img src="/logo.png" alt="logo" style={{width:"50px"}}/>
          <h3 className=" mt-2 mb-2">Welcome Back!</h3>
          <p className="text-muted fs-14">Sign up with your valid email and password</p>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="email"
                className="form-control"
                placeholder="Email"
                onChange={(e) =>
                  setForm({ ...form, email: e.target.value })
                }
              />
            </div>

            <div className="mb-3">
              <input
                type="password"
                className="form-control"
                placeholder="Password"
                onChange={(e) =>
                  setForm({ ...form, password: e.target.value })
                }
              />
            </div>

            <button className="btn btn-submit w-100" type="submit">
              Login
            </button>
            {error && <p style={{ color: "red" }}>{error}</p>}
          </form>

          <p className="text-muted fs-13 mt-3 mb-0">
            New user? <Link to="/register">Register</Link>
          </p>
        </div>
      </div>
      <div className="col-md-6">
              <img src={signup} className="signup-img" alt="banner"/>
      </div>
    </div>
  );
}

export default Login;